/**
 * @file Operation 页
 * @author fengfaxia(fengfaxia@baidu.com))
 * Copyright (c) 2018-06-13 Baidu
 */

import _ from 'lodash';
import React from 'react';
import {
    Tabs,
    Input,
    Button,
    message,
    Modal,
    Icon,
    Select
} from 'antd';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {connect} from 'react-redux';

import './index.less';
import api from '../../config';
import {
    createResponseCode,
    queryResponseCode
} from '../../common/enum';
// import {getLoginUrl} from '../../common/util';
import bgLogo from '../../img/logo@1x.png';
import {getDwzConsoleUrl} from '../../common/util';
import {Link} from 'react-router-dom';
import {setCurrentPage} from '../../actions/generalAction';

message.config({
    top: 60,
    maxCount: 1,
    duration: 1.5 // unit:s
});

const TabPane = Tabs.TabPane;
const Search = Input.Search;
const ShortPathLenMin = 1;
const ShortPathLenMax = 20;

class Operation extends React.Component {
    state = {
        longUrl: '',
        shortUrl: '',
        inputCreateTip: '',
        inputQueryTip: '',
        longDisplay: 'none',
        shortDisplay: 'none',
        alertDisplay: 'none',
        visible: false,
        termOfValidity: 'long-term'
    }
    linkToPrice() {
        this.props.dispatch(setCurrentPage('product'));
    }
    linkToFaq() {
        this.props.dispatch(setCurrentPage('faq'));
    }
    handleChange(value) {
        this.setState({
            termOfValidity: value
        });
    }
    createUrl(url) {
        /* eslint-disable */
        _hmt.push(['_trackEvent', '首页', 'homepage_click_create', '点击缩短网址']);

        if (!this.props.userName) {
            return this.showModal();
        }

        if (!url) {
            this.hiddenCreateResult();
            return this.showAlert('长网址不能为空');
        }

        url = _.trim(url);
        const tip = this.createValidate(url);
        if (tip) {
            this.hiddenCreateResult();
            return;
        }

        api.queryUrlV3([{
            LongUrl: url,
            TermOfValidity: this.state.termOfValidity
        }], {
                headers: {
                    'Dwz-Token': this.props.token,
                    'Content-Type': 'application/json; charset=UTF-8',
                    'Content-Language': 'zh'
                },
                method: 'POST'
            }).then(data => {
                let dataCode = data.Code;
                if (data.ShortUrls && data.ShortUrls.length && data.ShortUrls.Code) {
                    dataCode = data.ShortUrls[0].Code;
                }
                if (dataCode !== 0) {
                    this.hiddenCreateResult();
                    // TODO:后端接口修改完成后，使用Code进行判断
                    if (dataCode === -21) {
                        return this.showAlert('本月您累计免费创建“长期有效短网址”条数已达上限，推荐购买套餐包。'
                            + '<a target="_blank" href=' + getDwzConsoleUrl() + '>去看看></a>。');
                    } else if (dataCode === -30) {
                        return this.showAlert('您的账户已无可用点数，推荐购买套餐包。'
                            + '<a target="_blank" href=' + getDwzConsoleUrl() + '>去看看></a>。');
                    } else if (!createResponseCode.hasOwnProperty(dataCode+"")) {
                        let errMsg = data.ErrMsg;
                        if (data.ShortUrls && data.ShortUrls.length > 0) {
                            errMsg = data.ShortUrls[0].ErrMsg;
                        }
                        return this.showAlert(errMsg);
                    } else {
                        return this.showAlert(createResponseCode[dataCode]);
                    }
                }

                this.setState({
                    longUrl: data.ShortUrls[0].LongUrl,
                    shortUrl: data.ShortUrls[0].ShortUrl,
                    shortDisplay: 'block'
                });
            }).fail(error => {
                if (error && error.responseJSON) {
                    const code = error.responseJSON.Code;
                    let errMsg = error.responseJSON.ErrMsg;
                    if (error.responseJSON.ShortUrls && error.responseJSON.ShortUrls.length > 0) {
                        errMsg = error.responseJSON.ShortUrls[0].ErrMsg;
                    }
                    if (code === -21) {
                        return this.showAlert('本月您累计免费创建“长期有效短网址”条数已达上限，推荐购买套餐包。'
                            + '<a target="_blank" href=' + getDwzConsoleUrl() + '>去看看></a>。');
                    } else if (code === -30) {
                        return this.showAlert('您的账户已无可用点数，推荐购买套餐包。'
                            + '<a target="_blank" href=' + getDwzConsoleUrl() + '>去看看></a>。');
                    } else if (!createResponseCode.hasOwnProperty(code+"")) {
                        return this.showAlert(errMsg);
                    } else {
                        return this.showAlert(createResponseCode[code]);
                    }
                } else if (error && !error.responseJSON) {
                    this.showAlert('服务器错误');
                }
            });
    }
    queryUrl(url) {
        _hmt.push(['_trackEvent', '首页', 'homepage_click_query', '点击还原网址']);
        if (!this.props.userName) {
            return this.showModal();
        }

        if (!url) {
            this.hiddenQueryResult();
            return this.showAlert('短网址不能为空');
        }

        url = _.trim(url);
        const tip = this.queryValidate(url);
        if (tip) {
            this.hiddenQueryResult();
            return;
        }
        if (url.search(':') === -1) {
            url = 'https://dwz.cn/' + url;
        }
        api.queryUrl({
            shortUrl: url
        }, {
                headers: {
                    Token: this.props.token
                },
                method: 'POST'
            }).then(data => {
                if (data.Code !== 0) {
                    this.hiddenQueryResult();
                    this.setState({
                        longDisplay: 'none'
                    });
                    return this.showAlert(queryResponseCode[data.Code]);
                }

                this.setState({
                    originUrl: data.LongUrl,
                    longDisplay: 'block'
                });
            }).fail(error => {
                this.showAlert('服务器错误');
            });
    }
    /* eslint-disable */
    copyUrl(event) {
        message.success('复制成功')
    }
    createInputChange(e) {
        if (!this.props.userName) {
            return this.showModal();
        }

        const url = e && e.target && _.trim(e.target.value);
        this.setState({
            inputCreateTip: this.createValidate(url)
        });
    }
    queryInputChange(e) {
        if (!this.props.userName) {
            return this.showModal();
        }

        const url = e && e.target && _.trim(e.target.value);
        this.setState({
            inputQueryTip: this.queryValidate(url)
        });
    }
    showAlert(content) {
        if (this.state.alertDisplay === 'block') {
            this.setState({
                alertDisplay: 'none'
            });
        }
        this.setState({
            alertDisplay: 'block',
        });
        let elementId = 'alert-content'
        let alertContentDOM = document.getElementById(elementId)
        alertContentDOM.innerHTML = content
        setTimeout(() => this.setState({ alertDisplay: 'none' }), this.calcDisplayTime(alertContentDOM));
    }
    calcDisplayTime(contentDOM) {
        let searchTime = 1500  // unit:ms
        let readTimePerChar = 160 // unit:ms
        let totalReadTime = searchTime + contentDOM.textContent.length * readTimePerChar
        return totalReadTime
    }
    hiddenCreateResult() {
        this.setState({
            shortDisplay: 'none'
        });
    }
    hiddenQueryResult() {
        this.setState({
            longDisplay: 'none'
        });
    }
    /* eslint-disable */
    createValidate(url) {
        let tip;
        // 正则匹配其他协议
        if (/:\/\//.test(url) && !/^(http|https):\/\//.test(url)) {
            tip = '不支持当前协议类型，支持http或https协议';
        }
        else if (!/^(http|https):\/\//.test(url)) {
            tip = 'url格式不正确，请加上协议，如：http://www.baidu.com或https://www.baidu.com';
        }
        else {
            tip = '';
        }
        return tip;
    }
    queryValidate(url) {
        let tip = '';
        var regexOfUrl = new RegExp('^(http|https):\/\/dwz.cn\/[0-9a-zA-Z-_]{' + ShortPathLenMin + ',' + ShortPathLenMax + '}$');
        var regexOfPath = new RegExp('^[0-9a-zA-Z-_]{' + ShortPathLenMin + ',' + ShortPathLenMax + '}$');
        if (!regexOfUrl.test(url) && !regexOfPath.test(url)) {
            tip = '您查询的短网址不存在';
        }

        return tip;
    }
    hideModal() {
        _hmt.push(['_trackEvent', '登录框提示', 'loginguide_click_cancel', '点击取消']);
        this.setState({
            visible: false
        });
    }
    showModal() {
        this.setState({
            visible: true
        });
    }
    goLogin() {
        _hmt.push(['_trackEvent', '登录框提示', 'loginguide_click_contiue', '点击前往登录']);
        this.setState({
            visible: false
        });
        // window.location.href = getLoginUrl();
        window.open('https://console.bce.baidu.com/dwz/?channel=portal', '_blank');
    }
    render() {
        return (
            <div className="home-container">
                <div className="banner">
                    <img src={bgLogo} />
                </div>
                <div className="content">
                    <Tabs defaultActiveKey="short" type="card">
                        <TabPane tab="缩短网址" key="short">
                            <Search
                                placeholder="请输入长网址"
                                enterButton="缩短网址"
                                size="large"
                                onChange={value => this.createInputChange(value)}
                                onSearch={value => this.createUrl(value)}
                            />
                            有效期：
                            <Select
                                className="vadility"
                                defaultValue="long-term"
                                onChange={value => this.handleChange(value)}
                            >
                                <Option value="1-year">一年</Option>
                                <Option value="long-term">长期</Option>
                            </Select>

                            <div className="tip">{this.state.inputCreateTip}</div>
                            <div className="result" style={{
                                display: this.state.shortDisplay
                            }}>
                                短网址：<a href={this.state.shortUrl} target="_blank">{this.state.shortUrl}</a>
                                <CopyToClipboard text={this.state.shortUrl} onCopy={this.copyUrl}>
                                    <Button type="primary" className="copy-button" size="small" >复制网址</Button>
                                </CopyToClipboard><br />
                                <p>原网址：<a href={this.state.longUrl} target="_blank">{this.state.longUrl}</a></p>
                            </div>
                            <div className="free-tips-of-create">
                                提示：
                                <div>(1)使用短网址服务需完成企业实名认证。
                                    <a
                                        rel="noopener noreferrer"
                                        href="https://cloud.baidu.com/doc/UserGuide/s/3kuwcaomi"
                                        target="_blank"
                                    >
                                        企业实名认证文档&gt;
                                    </a>
                                </div>
                                <div>
                                    (2)所有用户免费享有100点/月，过期作废。<Link to="/console/product" onClick={() => this.linkToPrice()}>付费详情&gt;</Link>
                                </div>
                                <div style={{marginTop: '10px', color: 'red'}}>
                                    注意：短网址服务为付费服务，在短网址点数扣减为0后会按10元/万点价格扣减云账户余额；暂停服务后不计费，短链将可不可跳转；常见问题请查阅
                                    <Link to="/console/faq" onClick={() => this.linkToFaq()}>https://dwz.cn/console/faq</Link>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane tab="还原网址" key="retrieve">
                            <Search
                                placeholder="请输入短网址(如:https://dwz.cn/xxx)或直接输入后缀(如:xxx)"
                                enterButton="还原网址"
                                size="large"
                                onChange={value => this.queryInputChange(value)}
                                onSearch={value => this.queryUrl(value)}
                            />
                            <span className="tip">{this.state.inputQueryTip}</span>
                            <div className="result" style={{
                                display: this.state.longDisplay
                            }}>
                                <p>原网址: <a href={this.state.originUrl} target="_blank">
                                    {this.state.originUrl}</a>
                                </p>
                            </div>
                            <div className="free-tips-of-query">
                                提示：
                                <div>(1)使用短网址服务需完成企业实名认证。
                                    <a
                                        rel="noopener noreferrer"
                                        href="https://cloud.baidu.com/doc/UserGuide/s/3kuwcaomi"
                                        target="_blank"
                                    >
                                        企业实名认证文档&gt;
                                    </a>
                                </div>
                                <div>
                                    (2)所有用户免费享有100点/月，过期作废。<Link to="/console/product" onClick={() => this.linkToPrice()}>付费详情&gt;</Link>
                                </div>
                            </div>
                        </TabPane>
                    </Tabs>
                    <div className="alert" style={{
                        display: this.state.alertDisplay
                    }}>

                        <Icon type="exclamation-circle" style={{ color: '#FFA500' }} />
                        &nbsp;&nbsp;&nbsp;
                        <span id="alert-content" />
                    </div>
                    <Modal
                        title="登录提示"
                        visible={this.state.visible}
                        onOk={() => this.goLogin()}
                        onCancel={() => this.hideModal()}
                        okText="前往登录"
                        cancelText="取消">
                        为了保证您的网址安全，并提供更强大的个性化功能，请登录后继续使用百度短网址。谢谢您的支持！
                    </Modal>
                </div>
            </div>
        );
    }
}
export default connect(state => ({
    userName: state.userName,
    token: state.token
}))(Operation);
